import Joi from "joi";

const ConvertConsultationSchema = Joi.object({
  unit: Joi.string().trim().required().messages({
    "any.required": "Unit is required.",
    "string.empty": "Unit is required.",
  }),
  doctor: Joi.string().trim().required().messages({
    "any.required": "Doctor is required.",
    "string.empty": "Doctor is required.",
  }),
  visitType: Joi.string().trim().required().messages({
    "any.required": "Visit Type is required.",
    "string.empty": "Visit Type is required.",
  }),
  consultationDateTime: Joi.date().iso().required().messages({
    "any.required": "Consultation Date and Time is required.",
    "date.format": "Consultation Date and Time must be a valid ISO date.",
    "date.base": "Consultation Date and Time must be a valid date.",
  }),
  paymentStatus: Joi.string().valid("paid", "unpaid").required(),
  amount: Joi.number().when("paymentStatus", {
    is: "paid",
    then: Joi.number().optional(),
    otherwise: Joi.number().required().messages({
      "any.required": "Amount is required.",
      "number.base": "Amount must be a number.",
    })
  }
  ),
  payment: Joi.when('paymentStatus', {
    is: "paid",
    then: Joi.optional(),
    otherwise: Joi.object(
    {
    transactionId: Joi.string().allow(null).messages({
      "string.base": "Transaction ID must be a string.",
    }),
    transactionType: Joi.string().required().messages({
      "any.required": "Transaction Type is required.",
      "string.empty": "Transaction Type is required.",
    }),
    amountPaid: Joi.number().min(0).required().messages({
      "number.min": "Amount Paid must be 0 or greater.",
      "any.required": "Amount Paid is required.",
      "number.base": "Amount Paid must be a number.",
    }),
    remarks: Joi.string().allow(null).messages({
      "string.base": "Remarks must be a string.",
    }),
    paymentType: Joi.string().required().messages({
      "any.required": "Payment Type is required.",
      "string.empty": "Payment Type is required.",
    }),
  })
})
}).unknown(true);

export default ConvertConsultationSchema;
